const styleOptions = [
    '',
    'pageHeader1',
    'pageHeader3',
    'pageHeader4',
    'pageHeader5',
    'pageHeader7',
    'pageHeader9',
    'sectionHeader1Medium',
    'sectionHeader1Bold',
    'sectionHeader3Semibold',
    'sectionHeader3Bold',
    'subHeader1',
    'subHeader1Semibold',
    'subHeader1Bold',
    'subHeader3Medium',
    'subHeader3Bold',
    'subHeader5Medium',
    'subHeader5Bold',
];
export const headingConfig = {
    name: 'Heading',
    image: 'https://cdn.zappy.app/8bea639e04905dfa561777218501d1c4.svg',
    hideFromInsertMenu: true,
    category: 'Zapier Blocks',
    inputs: [
        {
            name: 'text',
            type: 'string',
        },
        {
            name: 'tag',
            type: 'string',
            enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
            defaultValue: 'h2',
        },
        {
            name: 'styles',
            type: 'object',
            subFields: [
                {
                    name: 'desktop',
                    type: 'string',
                    enum: styleOptions,
                },
                {
                    name: 'tablet',
                    type: 'string',
                    enum: styleOptions,
                },
                {
                    name: 'mobile',
                    type: 'string',
                    enum: styleOptions,
                },
            ],
            defaultValue: {
                desktop: 'pageHeader5',
                tablet: 'pageHeader7',
                mobile: 'pageHeader9',
            },
            showIf: (options) => !options.get('unstyled'),
        },
        {
            name: 'disableStyles',
            type: 'boolean',
        },
    ],
};
export const headingV2Config = Object.assign(Object.assign({}, headingConfig), { name: 'HeadingV2', friendlyName: 'Heading', hideFromInsertMenu: false });
//# sourceMappingURL=config.js.map